import { Fragment } from 'react'

import NavigationBar from '@/components/NavigationBar'
import Footer from '@/components/Footer'
import { AlternateLink } from '@/components/AlternateLink'

import AboutUs from '@/features/aboutUs/templates/AboutUs'
import OurBelief from '@/features/aboutUs/templates/OurBelief'
import AboutOurCompany from '@/features/aboutUs/templates/AboutOurCompany'
import OurPartners from '@/features/aboutUs/templates/OurPartners'
import Form from '@/features/landing/templates/Form'
import Blogs from '@/features/landing/templates/Blogs'
import Contact from '@/features/landing/templates/Contact'

import { BlogListItem } from '@/features/blogs/types/blog'

export interface AboutUsPageProps {
  blogs: BlogListItem[] | null
}

function AboutUsPage({ blogs }: AboutUsPageProps): React.ReactElement {
  return (
    <Fragment>
      <AlternateLink />
      <NavigationBar />
      <AboutUs />
      <OurBelief />
      <AboutOurCompany />
      <OurPartners />
      <Form />
      {blogs && <Blogs blogs={blogs} />}
      <Contact />
      <Footer />
    </Fragment>
  )
}

export default AboutUsPage
